import { Component, OnInit } from '@angular/core';
import { SettingService } from '../../../core/services/setting.service';
import { AuthService } from '../../../modules/auth/services/auth.service';
import { SETTINGS } from '../../../core/config/common.settings';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ChargebeeService } from '../../../core/services/chargebee.service';

declare var Chargebee: any;

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
})
export class BillingComponent implements OnInit {
  brand: any;

  constructor(
    private settingService: SettingService,
    private authService: AuthService,
    private message: NzMessageService,
    private chargebeeService: ChargebeeService
  ) {}

  ngOnInit(): void {
    this.onClickManage();
  }

  onClickManage(): void {
    //portal sessions
    Chargebee.init({
      site: SETTINGS.CHARGEBEE_SITE,
      isItemsModel: true,
    });
    const cbInstance = Chargebee.getInstance();
    cbInstance.setPortalSession( () => this.getPortalSession());
    const cbPortal = cbInstance.createChargebeePortal();
    const baseUrl = window.location.origin;

    cbPortal.open({
      redirectUrl: `${baseUrl}/admin/settings?tab=account`,
      loaded: () => {
        console.log('Portal has loaded.');
      },

      success: (data: any) => {
        console.log('Portal action successful:');
        window.location.href = baseUrl;
      },

      close: () => {
        console.log('Portal was closed.');
        window.location.href = `${baseUrl}/admin/settings?tab=account`;
      },
    });
  }

  async findBrand(): Promise<void> {
    try {
      const user = await this.authService.getLoggedInUser();
      this.brand = await this.settingService.findBrand(user.userId);
    } catch (e) {}
  }

  async getPortalSession(): Promise<any> {
    try {
      return await this.chargebeeService.createPortalSession();
    } catch (e: any) {
      this.message.error(e?.message || e);
    }
  }
}
